import React, { useEffect, useState } from "react";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import InputField from "../ui/InputField";

const AreaGrupoForm = ({ grupo, onClose, onSave }) => {
  const [name, setName] = useState("");
  const [isLoading, setIsLoading] = useState(false); // 🔹 loading

  useEffect(() => {
    if (grupo) setName(grupo.name);
  }, [grupo]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;

    try {
      setIsLoading(true);
      await onSave({ name });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-lg overflow-hidden">
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h2 className="text-lg font-semibold">
            {grupo ? "Editar grupo" : "Nuevo grupo"}
          </h2>
          <button onClick={onClose} className="text-xl" disabled={isLoading}>
            ✕
          </button>
        </div>

        <Card className="border-none shadow-none">
          <CardContent className="p-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              <InputField
                label="Nombre del grupo *"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Grupo"
                required
                disabled={isLoading}
              />

              <div className="flex justify-end gap-2 pt-4">
                <Button
                  variant="outline"
                  onClick={onClose}
                  type="button"
                  disabled={isLoading}
                >
                  Cancelar
                </Button>

                <Button type="submit" disabled={isLoading}>
                  {isLoading
                    ? grupo
                      ? "Actualizando..."
                      : "Creando..."
                    : grupo
                      ? "Actualizar"
                      : "Crear"}
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AreaGrupoForm;
